import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createLinkIn, setElementInnerHTML, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { getNotificationIconForType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UITopNotificationView {
    hide() {
        this.itemContainer.remove();
    }
    static createButton(parent, buttonText, action) {
        if (buttonText == undefined || action == undefined) return;
        const button = createLinkIn(parent, '', buttonText, 'top-notification-button');
        setElementOnClick(button, ()=>action(), true);
    }
    constructor(text, type, buttonText, action, removeAction, showCloseButton = true, duration){
        this.type = type;
        this.container = document.getElementById('top-notification-container');
        const icon = getNotificationIconForType(type);
        const lightningModifier = icon === LobbyImage.Lightning ? ' top-notification--lightning' : '';
        this.itemContainer = createDivIn(this.container, `top-notification${lightningModifier}`);
        const contentWrapper = createDivIn(this.itemContainer, 'notification-content');
        createImgIn(contentWrapper, icon, 'notification-icon');
        const textDiv = createDivIn(contentWrapper, '');
        setElementInnerHTML(textDiv, text);
        UITopNotificationView.createButton(contentWrapper, buttonText, action);
        if (duration !== undefined) {
            setTimeout(()=>{
                this.hide();
            }, duration);
        }
        if (showCloseButton == false) return;
        const closeButton = createImgIn(this.itemContainer, LobbyImage.XMark, 'top-notification-close-button');
        setElementOnClick(closeButton, ()=>{
            this.itemContainer.remove();
            if (removeAction != undefined) removeAction();
        });
    }
}
